import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';

import { useParams, useHistory } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { BackButton } from '../../components/Button';
import { DepartmentForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';
import { ViewTitle } from '../../components/ViewTitle';

export default function EditDepartment({ title, subtitle }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { id } = useParams();
  const department = useSelector((state) => state.department);


  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      name: department.name,
      description: department.description,
    },
  });

  useEffect(() => {
    dispatch(actions.departmentGet(id));
    return () => { };
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      await dispatch(
        actions.departmentPut(id, {
          ...data,
          access: {
            HRMS: true,
            CRM: true,
            IMS: false,
            MMS: false,
            SPM: true,
            WMS: true,
            CMS: false,
            DASHBOARD: true,
            SETTING: true,
            DISCOUNT: true,
            POS: true,
            BMS: false,
            HISTORY: true,
            RESERVE: true,
          },
        }),
      );
      await dispatch(actions.departmentGet(id));
      alert('สำเร็จ');
      history.goBack();
    } catch (error) {
      console.log(error);
    }
  };
  if (department.isLoading || department.rows) {
    return <Loading />;
  }
  if (!department.isLoading && department.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
          <div className="text-lg font-semibold ml-6">แก้ไขข้อมูลแผนก</div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <DepartmentForm
                errors={errors}
                department={department}
                control={control}
                Controller={Controller}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button
                  variant="contained"
                  type="submit"
                  startIcon={<SaveIcon />}
                >
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

EditDepartment.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditDepartment.defaultProps = {
  title: '',
  subtitle: '',
};
